(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["components"] = factory();
	else
		root["components"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 68);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/fp/omit");

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(69);


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = exports.componentPropTypes = exports.oneOfProps = exports.Col = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(3);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

__webpack_require__(70);

var colPropTypes = {
  numOfCols: _propTypes2.default.number.isRequired,
  className: _propTypes2.default.string,
  children: _propTypes2.default.any
};

var colDefaultProps = {
  numOfCols: 1
};

var Col = exports.Col = function Col(props) {
  if (!props.children) {
    return null;
  }

  var defaultClassName = 'col-1-' + props.numOfCols;
  var regex = /(col-\d-\d)/g;
  var needsColClass = !props.className || !regex.exec(props.className);
  var className = (0, _classnames2.default)(_defineProperty({}, defaultClassName, needsColClass), props.className);
  if (props.numOfCols === 1 && needsColClass) {
    className = (0, _classnames2.default)('col-1-1 widest', props.className);
  }
  return _react2.default.createElement(
    'div',
    _extends({}, (0, _omit2.default)(['numOfCols'])(props), { className: className }),
    props.children
  );
};

Col.propTypes = colPropTypes;
Col.defaultProps = colDefaultProps;

var mqs = ['base', 'mobile', 'mobile-and-fablet', 'mobile-and-tablet', 'fablet', 'fablet-and-tablet', 'fablet-up', 'fablet-down', 'tablet', 'tablet-and-desktop', 'tablet-up', 'tablet-down', 'desktop', 'desktop-up', 'desktop-down', 'wide-up'];

var oneOfProps = exports.oneOfProps = {
  rowsSpacedOn: mqs,
  colsSpacedOn: mqs,
  colsReversedOn: mqs,
  colsToRowsOn: mqs
};

var componentPropTypes = exports.componentPropTypes = {
  className: _propTypes2.default.string,
  rowsSpacedOn: _propTypes2.default.oneOf(oneOfProps.rowsSpacedOn),
  colsSpacedOn: _propTypes2.default.oneOf(oneOfProps.colsSpacedOn),
  colsReversedOn: _propTypes2.default.oneOf(oneOfProps.colsReversedOn),
  colsToRowsOn: _propTypes2.default.oneOf(oneOfProps.colsToRowsOn),
  children: _propTypes2.default.any
};

var getSuffix = function getSuffix(value) {
  if (value === 'base') {
    return '';
  }
  return '-on-' + value;
};

var getEmptyChildren = function getEmptyChildren(props) {
  if (props.children) {
    return _react2.default.Children.map(props.children, function (item) {
      if (!item) {
        return true;
      }
      if (!item.props) {
        return true;
      }
      return typeof item.props.children === 'undefined' || item.props.children === null ? true : null;
    });
  }

  return [];
};

var hasNoChildren = function hasNoChildren(props) {
  if (props.children) {
    var childLength = _react2.default.Children.count(props.children) || 0;
    return getEmptyChildren(props).length === childLength;
  }

  return true;
};

var getNewChildren = function getNewChildren(props) {
  var newChildren = [];

  if (props.children) {
    var childLength = _react2.default.Children.count(props.children) - getEmptyChildren(props).length || 0;

    newChildren = _react2.default.Children.map(props.children, function (item, index) {
      if (!item) {
        return false;
      }
      return _react2.default.cloneElement(item, {
        key: index,
        numOfCols: childLength
      });
    });
  }

  return newChildren;
};

var getRow = function getRow(props) {
  var className = (0, _classnames2.default)('row', _defineProperty({}, 'cols-spaced' + getSuffix(props.colsSpacedOn), props.colsSpacedOn), _defineProperty({}, 'cols-reversed' + getSuffix(props.colsReversedOn), props.colsReversedOn), _defineProperty({}, 'cols-to-rows' + getSuffix(props.colsToRowsOn), props.colsToRowsOn), _defineProperty({}, 'rows-spaced' + getSuffix(props.rowsSpacedOn), props.rowsSpacedOn), props.className);
  var newChildren = getNewChildren(props);

  return _react2.default.createElement(
    'div',
    _extends({}, (0, _omit2.default)(['rowsSpacedOn', 'colsSpacedOn', 'colsReversedOn', 'colsToRowsOn'])(props), {
      className: className }),
    newChildren
  );
};

var Row = exports.Row = function Row(props) {
  if (hasNoChildren(props)) {
    return null;
  }

  if (props.rowsSpacedOn) {
    return _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)('row', _defineProperty({}, 'rows-spaced' + getSuffix(props.rowsSpacedOn), props.rowsSpacedOn)) },
      getRow(props)
    );
  }

  return getRow(props);
};

Row.propTypes = componentPropTypes;
Row.defaultProps = {
  colsSpacedOn: 'base'
};

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/wonderbly-components/lib/Grid.js
// module id = 50
// module chunks = 0